export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '',
        this.entityId = item != null ? item.entityId : '',
        this.description = item != null ? item.description : ''
    }
}